import React from 'react';

const IconClose = ({ color, onClick }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    style={{transform: 'rotate(45deg)'}}
  >
    <path d="M10 4C10.552 4 11 4.448 11 5L10.999 9H15C15.552 9 16 9.448 16 10C16 10.552 15.552 11 15 11H10.999L11 15C11 15.552 10.552 16 10 16C9.448 16 9 15.552 9 15L8.999 11H5C4.448 11 4 10.552 4 10C4 9.448 4.448 9 5 9H8.999L9 5C9 4.448 9.448 4 10 4Z" fill={color} />
  </svg>
);

export default IconClose;
